import { ExternalLink, Phone } from "lucide-react";
import { TECH_EMERGENCY_URL, IMAGES, PHONE_DISPLAY, PHONE_TEL } from "../../data/site";

export const About = () => (
    <section id="about" data-testid="about-section" className="bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10 md:py-16">
            <div className="grid lg:grid-cols-5 gap-10 items-center">
                <div className="lg:col-span-2 relative">
                    <div className="absolute -top-3 -left-3 w-full h-full bg-orange-100 rounded-3xl" aria-hidden="true" />
                    <img
                        src={IMAGES.tom}
                        alt="Tom — your local computer technician, Adelaide born and raised"
                        data-testid="about-technician-photo"
                        className="relative rounded-2xl w-full max-w-sm object-cover shadow-md border border-slate-100"
                        loading="lazy"
                    />
                    <div className="absolute -bottom-4 left-4 bg-white rounded-xl shadow-md border border-slate-100 px-4 py-2.5">
                        <p className="text-xs font-semibold text-[#0F2E52]">Ask for Tom</p>
                        <p className="text-xs text-slate-500">Local — Semaphore &amp; surrounds</p>
                    </div>
                </div>
                <div className="lg:col-span-3 mt-6 lg:mt-0">
                    <p className="text-xs font-semibold uppercase tracking-widest text-[#ea580c] mb-2">
                        Your Local Technician
                    </p>
                    <h2 className="font-heading text-3xl md:text-4xl font-semibold tracking-tight text-[#0F2E52] mb-4">
                        Meet Tom
                    </h2>
                    <blockquote
                        data-testid="about-tom-quote"
                        className="border-l-4 border-[#ea580c] pl-4 text-lg md:text-xl font-medium text-slate-800 leading-relaxed mb-5"
                    >
                        "I'm Tom, I'm local, you can actually call me, and I'll come out and help."
                    </blockquote>
                    <div className="space-y-3 text-base md:text-lg leading-relaxed text-slate-700 mb-4">
                        <p>
                            Computer Repairs Semaphore is operated by Tech Emergency, an Adelaide-based onsite
                            computer repair and IT support business.
                        </p>
                        <p>
                            This website has been created specifically for customers throughout Semaphore, Port
                            Adelaide and Adelaide's western suburbs who need convenient onsite computer assistance.
                        </p>
                    </div>
                    <p className="font-semibold text-[#0F2E52] mb-6">
                        Born and raised in Adelaide.
                    </p>
                    <div className="flex flex-wrap items-center gap-x-6 gap-y-3">
                        <a
                            href={PHONE_TEL}
                            data-testid="about-call-link"
                            className="inline-flex items-center gap-2 text-blue-600 font-semibold hover:underline"
                        >
                            <Phone className="w-4 h-4" /> Call {PHONE_DISPLAY}
                        </a>
                        <a
                            href={TECH_EMERGENCY_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="about-tech-emergency-link"
                            className="inline-flex items-center gap-1.5 text-sm text-blue-600 font-medium hover:underline"
                        >
                            Visit the Tech Emergency website <ExternalLink className="w-4 h-4" />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </section>
);
